import React, { useState } from 'react';
import './MissionVision.css';
import { useSiteContent } from '../../context/SiteContentContext';

const DEFAULT_MISSION_SHORT = "HKI stands as a leading manufacturer of precision engineering products, serving as the pivotal link between quality and innovation. With a steadfast commitment to delivering comprehensive solutions, it caters to the diverse needs of industries, enterprises, and projects worldwide.";
const DEFAULT_MISSION_FULL = "Established with years of experience, the company's overarching mission is to \"make precision engineering accessible and reliable for all businesses,\" ensuring that technological advancements are within the reach of every enterprise, regardless of scale or sector.";

const DEFAULT_VISION_SHORT = "To be a global leader in the manufacturing of precision engineering products like fittings, valves, flanges, regulators, gauges, seals, sampling systems, and custom-engineered products, delivering sustainable solutions that meet our clients' unique requirements.";
const DEFAULT_VISION_FULL = "We aspire to expand our presence worldwide, establishing multiple offices and manufacturing units across the globe, while fostering a human-centric company culture that empowers and values our employees.";

const MissionVision = () => {
  const [showMissionFull, setShowMissionFull] = useState(false);
  const [showVisionFull, setShowVisionFull] = useState(false);
  const { siteContent } = useSiteContent();

  const missionShort = siteContent?.mission_short || DEFAULT_MISSION_SHORT;
  const missionFull = siteContent?.mission_full || DEFAULT_MISSION_FULL;
  const visionShort = siteContent?.vision_short || DEFAULT_VISION_SHORT;
  const visionFull = siteContent?.vision_full || DEFAULT_VISION_FULL;

  return (
    <section className="mission-vision-section">
      <div className="mission-vision-container">
        <div className="mission-vision-row">
          <div className="mission-vision-col mission-col">
            <h2 className="mission-vision-title">MISSION</h2>
            <div className="mission-vision-accent"></div>
            <div className="mission-vision-description">
              <p>{missionShort}</p>
              {showMissionFull && missionFull && <p>{missionFull}</p>}
            </div>
            {missionFull && (
              <button
                className="mission-vision-btn"
                onClick={() => setShowMissionFull(!showMissionFull)}
              >
                {showMissionFull ? 'Read Less' : 'Read More'}
              </button>
            )}
          </div>

          <div className="mission-vision-col vision-col">
            <h2 className="mission-vision-title">VISION</h2>
            <div className="mission-vision-accent"></div>
            <div className="mission-vision-description">
              <p>{visionShort}</p>
              {showVisionFull && visionFull && <p>{visionFull}</p>}
            </div>
            {visionFull && (
              <button
                className="mission-vision-btn"
                onClick={() => setShowVisionFull(!showVisionFull)}
              >
                {showVisionFull ? 'Read Less' : 'Read More'}
              </button>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default MissionVision;
